import { ReactNode } from 'react';

import Button from '@sorare/core/src/atoms/buttons/Button';

type Props = {
  to?: string;
  onClick?: () => void;
  children: ReactNode;
};

export const ProfileCta = ({ to, onClick, children }: Props) => {
  if (to) {
    return (
      <Button color="tertiary" size="medium" to={to}>
        {children}
      </Button>
    );
  }

  return (
    <Button color="tertiary" size="medium" onClick={onClick}>
      {children}
    </Button>
  );
};
